import React from "react";
import Notifications from "../components/Notifications";

const NotificationsPage = () => (
  <div className="container px-3">
    <h2 className="page-title mb-4">🔔 Notifications</h2>
    <Notifications />
  </div>
);

export default NotificationsPage;
